import { useContext, useEffect, useState } from "react";
import ProductOptions from "./ForOrderOptions/ProductOptions";
import { CurrentPContext, MasterContext, OrderContext } from "../../ContextApi/context";
import TheMount from "../../OrderSettings/TheMount";
import ConnUrls from "../../Connections/ConnectURL";
import ProductComboOptions from "./ForOrderOptions/ProductComboOptions";
import OrderFunctions from "../../OrderSettings/OrderFunctions";

const ProductItemRegular = (props) => {

    const [order, setOrder] = useContext(OrderContext);
    const [master] = useContext(MasterContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [imInOrder, setImInOrder] = useState(false);
    const [popMeUp, setPopMeUp] = useState({ timestamp: 0, itemId: null });
    const [inOrderIndex, setInOrderIndex] = useState(-1);
    const [duplicates, setDuplicates] = useState([]);

    const [specials, setSpecials] = useState([]);
    const [addsPrice, setAddsPrice] = useState(0);
    const [tempMount, setTempMount] = useState(1);

    const isOutOfStock = !props.divitm.inStock || false;

    // בדיקה אם המוצר בהזמנה
    useEffect(() => {
        // ✅ אם ההזמנה ריקה - וודא שהמוצר לא מסומן כבהזמנה
        if (!order.Orders || order.Orders.length === 0) {
            if (imInOrder) {
                setImInOrder(false);
                setInOrderIndex(-1);
            }
            return;
        }

        let chkInOrder = (order.restId == currentPage._id);
        if (chkInOrder) {
            let getItm = order.Orders.findIndex(
                el => el.ordProdID == props.itemId &&
                    (el.orderDiviId == props.divitm._id || props.divitm._id.ObjectId)
            )

            if (getItm != -1) {
                if (!imInOrder) {
                    setInOrderIndex(getItm);
                    setImInOrder(true);
                }
            } else {
                if (imInOrder) {
                    setImInOrder(false);
                    setInOrderIndex(-1);
                }
            }
        } else {
            // ✅ אם המסעדה לא תואמת - נקה
            if (imInOrder) {
                setImInOrder(false);
                setInOrderIndex(-1);
            }
        }
    }, [order]);

    useEffect(() => {
        if (props.autoOpen === true && !isOutOfStock) {
            setTimeout(() => {
                popIT();
            }, 100);
        }
    }, []);

    const tempOrderProds = (prods, calculatedAddsPrice) => {
        let tempAddsPrice = 0;

        // אם קיבלנו מחיר מחושב - השתמש בו
        if (calculatedAddsPrice !== undefined) {
            tempAddsPrice = calculatedAddsPrice;
        } else {
            // אחרת חשב בעצמך
            prods.map((item) => {
                item.spec.map((prc) => {
                    tempAddsPrice = parseInt(tempAddsPrice) +
                        (parseInt(prc.addToPrice != "" ? prc.addToPrice : 0) * parseInt(prc.itmsMount || 1));
                })
            })
        }

        setSpecials(prods);
        setAddsPrice(tempAddsPrice);
    }

    const addDuplicate = () => {
        const newItemId = `${props.itemId}_dup_${Date.now()}`;
        let newDivItem = JSON.parse(JSON.stringify(props.divitm));

        if (newDivItem.prodOptions) {
            newDivItem.prodOptions = newDivItem.prodOptions.map(opt => ({
                ...opt,
                selected: Array.isArray(opt.selected) ? [] : 0
            }));
        }

        setDuplicates([...duplicates,
        <ProductItemRegular
            key={newItemId}
            itemId={newItemId}
            divitm={newDivItem}
            doDeliver={props.doDeliver}
            doTakeAway={props.doTakeAway}
            onlyPhone={props.onlyPhone}
            myClass=""
            autoOpen={true}
        />
        ]);
    }

    const addToOrder = (forcedSpecials, forcedAddsPrice, forcedMount) => {
        if (isOutOfStock) return;

        // אם קיבלנו נתונים ישירות - השתמש בהם, אחרת השתמש ב-state
        const finalSpecials = forcedSpecials !== undefined ? forcedSpecials : specials;
        const finalAddsPrice = forcedAddsPrice !== undefined ? forcedAddsPrice : addsPrice;

        let tmp = {
            ordProdID: props.itemId,
            productName: props.divitm.prodName,
            prodImageUrl: props.divitm.prodImageUrl,
            prodPrice: props.divitm.prodPrice,
            addsPrice: finalAddsPrice || 0,
            specials: finalSpecials || [],
            mount: forcedMount !== undefined ? forcedMount : tempMount,
            orderItemId: props.itemId,
            cashRegMakat: props.divitm.cashRegMakat,
            orderDiviId: props.divitm._id,
            isCombo: props.divitm.isCombo ? props.divitm.isCombo : false,
            chkProdSauces: props.divitm.chkProdSauces ? props.divitm.chkProdSauces : false,
            chkProdValSauces: props.divitm.chkProdValSauces ? props.divitm.chkProdValSauces : "",
            prodInfo: props.divitm.prodInfo || "",
            unitPrice: props.divitm.unitPrice
        };

        // רשת ביטחון מפני סל מעורב: אם הסל עדיין שייך לעסק אחר, פותחים סל
        // חדש במקום לערבב מוצרים משני עסקים תחת הזמנה אחת.
        // בזרימה תקינה הלקוח כבר נשאל על כך בכניסה לעמוד (RestaurantPage),
        // ולכן זה לא אמור לקרות — אבל כאן זו הנקודה היחידה שאי אפשר לעקוף.
        if (OrderFunctions.cartBelongsToOtherRest(order, currentPage._id)) {
            order.Orders = [];
        }

        order.Orders.push(tmp);
        setInOrderIndex(order.Orders.length - 1);
        order.restId = currentPage._id;
        order.restName = currentPage.buissName;
        order.GoogleLink = currentPage.GoogleLink;
        setOrder({ ...order });
        setImInOrder(true);
    }

    const removeFromOrder = (ordItmId) => {
        setImInOrder(false);
        setInOrderIndex(-1);
        setTempMount(1);
        setPopMeUp({ timestamp: 0, itemId: null });

        let filt = order.Orders.filter(itm => itm.orderItemId != ordItmId);
        order.Orders = filt;
        setOrder({ ...order });
    }

    const popIT = () => {
        if (isOutOfStock) return;
        if (!imInOrder) {
            setTempMount(1);
        }
        setPopMeUp({ timestamp: Date.now(), itemId: props.itemId });
    }

    const smDisp = () => {
        let imgLnk = `${(props.divitm.prodImageUrl != null && props.divitm.prodImageUrl != "") ? props.divitm.prodImageUrl
            : (currentPage.mnuItemMainImg != null && currentPage.mnuItemMainImg != "") ? currentPage.mnuItemMainImg : ""}`
        imgLnk = (imgLnk != "") ? ConnUrls.servMediasUrl + imgLnk : "";

        // אם המוצר לא במלאי - תצוגה פשוטה ללא אינטראקציה
        if (isOutOfStock) {
            return (
                <div id={`prodBlockS_${props.itemId}`} className={`productDiv prodSmall outOfStock`}>
                    {imgLnk != "" &&
                        <div className={`prodImageWrap prodImageWrapSmall`}>
                            <img className={"prodImage posUnset"} src={imgLnk} alt={currentPage.altTags || currentPage.pageName || ""} />
                        </div>
                    }
                    <div className={"prodDetails"}>
                        <div className={`MyFont mnuDivPrdcbold MbigFont`}>{props.divitm.prodName}</div>
                        {/* <div className="notForDelivery">אזל מהמלאי</div> */}
                        <div className={"prodDetailsShort"}>
                            <div className={"mnuDivPrdcReg prodSText"}>
                                <div className={"inProdTxt"}>{props.divitm.prodProducts}</div>
                                {props.divitm.prodProducts?.length > 80 ? <span className={"dotesL"}>...</span> : ""}
                            </div>
                        </div>
                        <div className={`priceln`}>₪{parseFloat(props.divitm.prodPrice).toFixed(2)}</div>
                    </div>
                </div>
            )
        }

        // תצוגה רגילה למוצר זמין
        return (
            <div id={`prodBlockS_${props.itemId}`}
                className={`productDiv prodSmall pointing`}
                role="button"
                tabIndex={0}
                onClick={(e) => {
                    if (e.target.closest('.prodOptions') || e.target.closest('.prodComboOptions')) {
                        return;
                    }
                    if ((!master.blockDeliverys.block || !master.blockPickUps.block) && props.divitm.okToDeliver) {
                        e.stopPropagation();
                        popIT();
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key !== 'Enter' && e.key !== ' ') return;
                    if (e.target.closest('.prodOptions') || e.target.closest('.prodComboOptions')) {
                        return;
                    }
                    if ((!master.blockDeliverys.block || !master.blockPickUps.block) && props.divitm.okToDeliver) {
                        e.preventDefault();
                        popIT();
                    }
                }}>
                {imgLnk != "" &&
                    <div className={`prodImageWrap prodImageWrapSmall`}>
                        {((!master.blockDeliverys.block || !master.blockPickUps.block) && props.divitm.okToDeliver) ?
                            !imInOrder ?
                                <div className={"addToOrderBtnOnImage pointing"}>{"+"}</div> :
                                <div className={"addToOrderBtnOnImage greenB pointing"}>
                                    {order.Orders.find(el => el.ordProdID == props.itemId)?.mount || "+"}
                                </div>
                            : ""
                        }
                        <img className={"prodImage posUnset"} src={imgLnk} onClick={() => { }} alt={currentPage.altTags || currentPage.pageName || ""} />
                    </div>
                }

                <div className={"prodDetails"}>
                    <div className={`MyFont mnuDivPrdcbold MbigFont`}>{props.divitm.prodName}</div>

                    {((!master.blockDeliverys.block || !master.blockPickUps.block) && props.divitm.okToDeliver) ?
                        <>
                            {props.divitm.isCombo ?
                                <ProductComboOptions
                                    product={props.divitm}
                                    PopMeUp={popMeUp}
                                    tempOrderProds={(prods) => tempOrderProds(prods)}
                                    itemId={props.itemId}
                                    imInOrder={imInOrder}
                                    removeFromOrder={() => removeFromOrder(props.itemId)}
                                    inOrderIndex={inOrderIndex}
                                    addDuplicate={addDuplicate}
                                    addToOrder={addToOrder}
                                    imgLnk={imgLnk}
                                    closePopup={() => setPopMeUp({ timestamp: 0, itemId: null })} />
                                :
                                <ProductOptions
                                    product={props.divitm}
                                    PopMeUp={popMeUp}
                                    tempOrderProds={(prods) => tempOrderProds(prods)}
                                    itemId={props.itemId}
                                    imInOrder={imInOrder}
                                    inOrderIndex={inOrderIndex}
                                    addDuplicate={addDuplicate}
                                    addToOrder={addToOrder}
                                    removeFromOrder={() => removeFromOrder(props.itemId)}
                                    tempMount={tempMount}
                                    setTempMount={setTempMount}
                                    closePopup={() => setPopMeUp({ timestamp: 0, itemId: null })}
                                    imgLnk={imgLnk} />
                            }
                        </> : !props.divitm.okToDeliver && <div className="notForDelivery">להזמנה במסעדה בלבד</div>
                    }

                    <div className={"prodDetailsShort"}>
                        <div className={"mnuDivPrdcReg prodSText"}>
                            <div className={"inProdTxt"}>{props.divitm.prodProducts}</div>
                            {props.divitm.prodProducts?.length > 80 ? <span className={"dotesL"}>...</span> : ""}
                        </div>
                    </div>

                    <div className={`priceln`}>₪{parseFloat(props.divitm.prodPrice).toFixed(2)}</div>
                </div>
            </div>
        )
    }

    return (
        <div key={props.itemId} id={props.itemId} className={`${props.myClass}`} style={{ position: "relative" }}>
            {props.myClass != "" ? <div className={"overLay"}></div> : ""}
            <div className={"prods"}>{smDisp()}</div>
            <div className={"duplis"}>{duplicates}</div>
        </div>
    );
}

export default ProductItemRegular;